import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VCard,{staticClass:"shadowCard"},[_c(VSubheader,[_vm._v("Resultados EXCI")]),(_vm.verExci)?_c(VCardText,[_c('div',{staticClass:"row justify-content-md-center"},[_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"500px"}})])]):_vm._e()],1),(_vm.respuestaAlerta)?_c('Alerta',{attrs:{"parametros":_vm.parametros}}):_vm._e(),(_vm.cargar)?_c('Loader',{attrs:{"loader":_vm.loader}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }